<script lang="ts">
    import Card from "../../Core/Card.svelte";
    import { Col, Row } from "sveltestrap";
    import TopDealerCarousel from "./TopDealerCarousel.svelte";
    import { Morethanlastyear,TopDealer } from "../../../utils/Constant/Constant";
</script>

<Col xl="6" class="box-col-12 des-xl-100 top-dealer-sec">
    <Card cardHeaderprops="pb-0">
        <div class="header-top d-sm-flex justify-content-between align-items-center" slot="customheader" >
            <h5>{TopDealer}</h5>
            <div class="center-content">
                <p class="d-sm-flex align-items-center">
                    <span class="m-r-10">845 Dealer</span><i
                        class="toprightarrow-primary fa fa-arrow-up m-r-10"
                    />86% {Morethanlastyear}
                </p>
            </div>
        </div>
        <div slot="contentbody">
            <div class="item">
                <Row>
                    <TopDealerCarousel />
                </Row>
            </div>
        </div>
    </Card>
</Col>
